<template>
    <div v-if="!loading" id="content">
        <router-view />
        <PageFooter />
    </div>
</template>

<script>
import PageFooter from '@/components/Footer.vue'
import Cookies from 'js-cookie'
import {
    TLD,
    COOKIE_ACCESS_TOKEN_MEMBER,
    COOKIE_REFRESH_TOKEN_MEMBER
} from '@/common/constants'

export default {
    components: {
        PageFooter
    },
    data: function () {
        return {
            loading: true
        }
    },
    created: async function () {
        if (TLD.endsWith('ondigitalocean.app')) {
            document.body.innerHTML = 'oops!'
            return
        }

        await this.$router.isReady()

        // check if member token exists
        const _access_token_member = Cookies.get(COOKIE_ACCESS_TOKEN_MEMBER)
        const _refresh_token_member = Cookies.get(COOKIE_REFRESH_TOKEN_MEMBER)

        if (_access_token_member || _refresh_token_member) {
            this.$store.commit('RESTORE_TOKEN_MEMBER', {
                access_token: _access_token_member,
                refresh_token: _refresh_token_member
            })

            // Rotate once when the app opens. Besides refreshing proactively,
            // this upgrades cookies created by older releases to the new lifetime.
            if (_refresh_token_member) {
                const response = await this.$store.dispatch('REFRESH_ACCESS_TOKEN')
                if (response && [401, 403].includes(response.status)) {
                    this.$store.commit('UNSET_MEMBER')
                    this.$store.commit('UNSET_TOKEN_MEMBER')
                }
            }
        }

        await this.loaded()
    },
    methods: {
        loaded: async function () {
            this.loading = false
            setTimeout(function () {
                document.body.classList.remove('loading')
                document.getElementById('app-loader')?.remove()
            }, 1000)
        }
    }
}
</script>

<style lang="scss">
    @import '@/assets/scss/style.scss';
</style>
